import React, { useContext, useEffect } from "react";
import axios from "axios";
import RegistrationContext from "../../contexts/RegistrationContext";
import { base_url } from "../../config";
import "./style.scss"; // Ensure this file contains the updated styles
import {
  LayoutDashboard,
  UsersIcon,
  Plane,
  GraduationCapIcon,
  NotebookText,
  Barcode,
  MonitorCheck,
  Sheet,
  Camera,
  BadgeCheck,
} from "lucide-react";

function AdminMenu() {
  const { setError, screen, setScreen, reloadAdminBadges, permissions } =
    useContext(RegistrationContext);

  const [badges, setBadges] = React.useState({});
  const handler = async (step) => {
    setError("");
    try {
      await axios.post(`${base_url}/api/jump`, { step });
      setScreen(step);
    } catch (error) {
      setError("Not accessible step");
    }
  };

  const getAdminBadges = async () => {
    try {
      const response = await axios.get(`${base_url}/api/admin/badges`);

      setBadges(response.data);
    } catch (error) {
      setError("Error fetching badges");
    }
  };

  useEffect(() => {
    getAdminBadges();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reloadAdminBadges]);

  const DisplayBadge = ({ step }) => {
    const stepName = step.replace("admin-", "");
    if (badges[stepName] === undefined) {
      return null;
    }
    if (badges[stepName] === 0) {
      return null;
    }
    const badgeCount = badges[stepName];

    return (
      <div className="absolute  px-1 top-1 right-0 left-4 transform translate-x-1/2 -translate-y-1/2 bg-orange-500 text-white text-xs rounded-full w-4 h-4 flex items-center justify-center">
        {badgeCount}
      </div>
    );
  };

  const menu = [];
  menu.push({
    icon: <LayoutDashboard className="w-5 h-5" />,
    name: "Dashboard",
    value: "admin-dashboard",
  });
  menu.push({
    icon: <UsersIcon className="w-5 h-5" />,
    name: "Registrations",
    value: "admin-registrations",
  });
  menu.push({
    icon: <GraduationCapIcon className="w-5 h-5" />,
    name: "WS & Tut",
    value: "admin-workshops",
  });
  if (permissions.includes("ijcai_codes")) {
    menu.push({
      icon: <Barcode className="w-5 h-5" />,
      name: "Gift Codes",
      value: "admin-codes",
    });
  }
  if (permissions.includes("ijcai_students")) {
    menu.push({
      icon: <GraduationCapIcon className="w-5 h-5" />,
      name: "Student Validations",
      value: "admin-student",
    });
    menu.push({
      icon: <BadgeCheck className="w-5 h-5" />,
      name: "EurAI Validations",
      value: "admin-eurai",
    });
  }
  if (permissions.includes("ijcai_visa")) {
    menu.push({
      icon: <Plane className="w-5 h-5" />,
      name: "Visa Validations",
      value: "admin-visa",
    });
  }
  if (permissions.includes("ijcai_papers")) {
    menu.push({
      icon: <NotebookText className="w-5 h-5" />,
      name: "Paper Validations",
      value: "admin-paper",
    });
  }
  if (permissions.includes("ijcai_exhibitors")) {
    menu.push({
      icon: <MonitorCheck className="w-5 h-5" />,
      name: "Exhibitors",
      value: "admin-exhibitors",
    });
  }
  menu.push({
    icon: <Camera className="w-5 h-5" />,
    name: "Press and Extra",
    value: "admin-press",
  });
  menu.push({
    icon: <Sheet className="w-5 h-5" />,
    name: "Exports",
    value: "admin-exports",
  });

  return (
    <div className="bg-black ">
      <div className="container text-xs px-0">
        <div className="stepper flex justify-left gap-2 ">
          {menu.map((step, index) => {
            const isCurrent = step.value !== screen;

            return (
              <div
                key={index}
                className={`step flex flex-col items-center  py-2 w-32 ${
                  isCurrent
                    ? "text-blue-400 font-bold "
                    : "text-white font-bold bg-black"
                }`}
                onClick={() => (isCurrent ? handler(step.value) : null)}
              >
                <div className="relative flex items-center">
                  {step.icon}
                  <DisplayBadge step={step.value} />
                </div>

                <span>{step.name}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default AdminMenu;
